import React, { useEffect, useState } from 'react';
import './About.css';
import axios from 'axios';
import Editor from '../../../components/Editor/Editor';

function About(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [aboutUs, setAboutUs] = useState('');

  useEffect(() => {
    axios
      .get('https://somadha.com/api/static-fields')
      .then(function (response) {
        // handle success

        const obj = response.data.about_us;

        setAboutUs(obj);
      })
      .catch(function (error) {
        // handle error
      });
  }, []);

  return (
    <div
      className='container'
      style={{
        marginTop: '30px',
        padding: '30px 40px',
        border: '1px #ccc solid',
        borderRadius: '5px',
      }}
    >
      {/* <p>{aboutUs}</p> */}
      <Editor readOnly defaultValue={aboutUs} />
    </div>
  );
}

export default About;
